const RequestStatus = {
	pending: 'pending',
	approved: 'approved',
	rejected: 'rejected',
	approvedArchived: 'approvedArchived',
	cancelled: 'cancelled',
};

export default RequestStatus;
